type OwnProps = {
  cta: React.ReactNode;
};

export default function DefaultFinanceCard({ cta }: OwnProps) {
  const backgroundImage = `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/finance-background-7-24.png`;

  return (
    <div
      className="flex flex-col justify-between rounded-[6px] border border-grey-2 bg-cover bg-center p-2xl text-white"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
      data-qa="Finance promo tile"
    >
      <div className="flex flex-auto flex-col gap-xl pb-xl">
        <h3 className="tl-header-m">Finance with Carvana</h3>
        <p className="tl-body-m">
          No hit to your credit, see real monthly payments while shopping.
        </p>
      </div>

      {cta}
    </div>
  );
}
